import { render, staticRenderFns } from "./MensagemSucesso.vue?vue&type=template&id=f887745a"
import script from "./MensagemSucesso.vue?vue&type=script&lang=js"
export * from "./MensagemSucesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports